export const ciscoSmaKeys = {
  generalInfo: hash => ["cisco_sma_general_info", hash],
  displayStatus: hash => ["cisco_sma_display_status", hash],
  showLinks: hash => ["cisco_sma_show_links", hash],
  droppedFiles: hash => ["dropped_files", hash],
  iocs: hash => ["iocs", hash],
  networking: hash => ["networking", hash],
  signatures: hash => ["signatures", hash],
  counts: hash => ["counts", hash]
};
